<template>
    <div>
      <div 
        v-for="item in reversedData" 
        :key="item.id"
        class="reply-item"
      >
        <div class="content_reply" v-html="item.message"></div>
        <div class="autor">
          <span class="logo">{{ obterIniciais(item.userName) }}</span>
          <span class="name">{{ item.userName }}</span>
          <span class="date">{{ formatarData(item.dateInsert) }}</span>
        </div>
      </div>
      
      <div v-if="!messages.length" class="empty-state">
        Nenhuma resposta encontrada.
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ReplyInquiry',
    
    props: {
      id: {
        type: String,
        required: true
      },
      messages: {
        type: Array,
        default: () => []
      }
    },
    
    computed: {
      reversedData() {
        return [...this.messages].reverse()
      }
    },
    
    methods: {
      formatarData(dateString) {
        if (!dateString) return 'Data inválida'
        
        try {
          const dataObj = new Date(dateString)
          
          if (isNaN(dataObj.getTime())) {
            return 'Data inválida'
          }
          
          const dia = String(dataObj.getDate()).padStart(2, '0')
          const mes = String(dataObj.getMonth() + 1).padStart(2, '0')
          const ano = String(dataObj.getFullYear() % 100).padStart(2, '0')
          
          return `${dia}/${mes}/${ano}`
        } catch {
          return 'Data inválida'
        }
      },
      
      obterIniciais(nome) {
        if (!nome || typeof nome !== 'string') {
          return '??'
        }
        
        return nome
          .trim()
          .split(' ')
          .filter(palavra => palavra.length > 0)
          .slice(0, 2)
          .map(palavra => palavra[0].toUpperCase())
          .join('')
      }
    }
  }
  </script>
  
  <style scoped>
  .reply-item {
    background-color: #f3f3f3;
    margin: 12px 0px;
    padding: 24px;
    border-radius: 5px;
  }
  
  .reply-item .name {
    font-weight: bold;
    font-size: 18px;
    margin-top: 0;
    margin-right: 16px;
  }
  
  .reply-item .date {
    font-size: 12px;
    color: #19c7d0;
  }
  
  .empty-state {
    text-align: center;
    padding: 20px;
    color: #666;
    font-style: italic;
  }
  </style>